import { ModalContext } from "app/app";
import { Fragment, useContext } from 'react';
import styles from "./styles.module.scss";
import axios from "axios";
import { ViewContext } from "components/lib";
import { useState } from "react";

export function ReopenTicketModal() {
  const { modal, setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  const [sending, setSending] = useState(false);

  const handleCancel = () => {
    setModal("");
  };

  const handleConfirm = async () => {
    setSending(true);
    try {
      const response = await axios.put(`/api/tickets/${modal.data.id}`, 
        {
          status: 'Active',
          ticketStatus: 'In Progress',
        }, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.success) {
        context.notification.show(
          "Ticket reopened successfully!",
          "success",
          true,
          "toast",
          "check-circle"
        );
        setSending(false);
        setModal("");
        window.location.reload();
      }
    } catch (error) {
      context.notification.show(
        "Couldn't change ticket status, please try again later.",
        "error",
        true,
        "toast",
        "check-circle"
      );
    }
  };

  return (
    <Fragment>
      {modal.name === "reopen_ticket_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div
                style={{
                  fontStyle: "normal",
                  fontSize: 22,
                  marginBottom: 10,
                  marginLeft: 20,
                  color: "black",
                }}
              >
                Reopen Ticket
              </div>
              <div
                style={{
                  fontStyle: "normal",
                  fontSize: 16,
                  marginBottom: 20,
                  marginLeft: 20,
                  color: "black",
                }}
              >
                Are you sure you want to open again the ticket?
              </div>
              <div
                className={styles.footer}
                style={{ justifyContent: "end", paddingRight: '8px' }}
              >
                <div className={styles.buttons}>
                  <button
                    className={styles.cancel}
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button
                    className={styles.save}
                    onClick={handleConfirm}
                    disabled={sending}
                  >
                    {sending ? "Sending..." : "Confirm"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}